import { useState } from "react";
import { Smartphone, Monitor, ArrowLeft } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PlanillaForm } from "@/components/planillas/PlanillaForm";

// Temporary, side-effect-free preview of the in-memory template draft.
// Reuses PlanillaForm (mode="preview") so it never diverges from real fill.
export function PlanillaPreview({ open, onClose, template }) {
  const [device, setDevice] = useState("mobile"); // mobile first

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[92vh] max-w-4xl flex-col gap-0 overflow-hidden p-0" aria-describedby={undefined}>
        <DialogTitle className="sr-only">Vista previa de planilla</DialogTitle>
        <div className="flex items-center justify-between border-b px-4 py-3">
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="sm" data-testid="preview-back-btn" onClick={onClose} className="rounded-lg">
              <ArrowLeft className="mr-1 h-4 w-4" /> Volver a editar
            </Button>
            <span className="hidden text-sm text-[#68756F] sm:inline">Vista previa (no genera registros)</span>
          </div>
          <div className="flex items-center gap-1 rounded-xl bg-slate-100 p-1">
            <button data-testid="preview-device-mobile" onClick={() => setDevice("mobile")}
              className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${device === "mobile" ? "bg-white text-[#2563EB] shadow-sm" : "text-slate-500"}`}>
              <Smartphone className="h-3.5 w-3.5" /> Móvil
            </button>
            <button data-testid="preview-device-desktop" onClick={() => setDevice("desktop")}
              className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors ${device === "desktop" ? "bg-white text-[#2563EB] shadow-sm" : "text-slate-500"}`}>
              <Monitor className="h-3.5 w-3.5" /> Escritorio
            </button>
          </div>
        </div>

        <div className="flex min-h-0 flex-1 justify-center overflow-hidden bg-slate-100 p-4">
          <div className={`flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-background shadow-sm ${device === "mobile" ? "w-full max-w-[400px]" : "w-full max-w-[760px]"}`}
            data-testid="preview-frame">
            <PlanillaForm template={template} mode="preview" embedded onClose={onClose} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
